module.exports = __webpack_public_path__ + "media/images/default/pages/about/main/protected-heart-a993790e8830c2e784dbb7546eff4445.svg";